export default __webpack_public_path__ + "static/media/user-photo.70098826.svg";